/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});
$(document).ready(function () {
  function tabs() {
    $('.tabs-content-dots li').on('click', function (e) {
      e.preventDefault();
      $(this).closest('.rte').find('.tabs li').eq($(this).index()).click();
      $(this).addClass('active').siblings().removeClass('active');
    });
    $('.tabs li').on('click', function (e) {
      $(this).closest('.rte').find('.tabs-content-dots li').removeClass('active').eq($(this).index()).addClass('active');
    });
  }

  function footer() {
    $('.footer-linklist .section-title').on('click', function () {
      $(this).next().toggleClass('active');
      $(this).toggleClass('active')
    })
  }

  function headerTabs() {
    // $('.navigation.navigation-desktop .mega-nav-list li').on('click', function (e) {
    //     e.preventDefault();
    //     $(this).closest('.mega-nav-list-wrapper').find('.mega-nav-list-child').removeClass('active').eq($(this).index()).addClass('active');
    //     $(this).addClass('active').siblings().removeClass('active');
    // });

    $('.navigation.navigation-desktop .mega-nav-list li').hover(
      function () {
        $(this).closest('.mega-nav-list-wrapper').find('.mega-nav-list-child').removeClass('active').eq($(this).index()).addClass('active');
        $(this).addClass('active').siblings().removeClass('active');
      }, function () {
        // $(this).closest('.mega-nav-list-wrapper').find('.mega-nav-list-child').removeClass('active').eq($(this).index()).removeClass('active');
        // $(this).addClass('active').siblings().removeClass('active');
      }
    );

  }

  function infoLine() {
    $('[data-infoline]').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
    })
  }

  function customTabs() {
    $('ul.tabs__caption').each(function (i) {
      var storage = localStorage.getItem('tab' + i);
      if (storage) {
        $(this).find('li').removeClass('active').eq(storage).addClass('active')
          .closest('div.tabs-wrap').find('div.tabs__content').removeClass('active').eq(storage).addClass('active');
      }
    });


    $('body').on('click', 'ul.tabs__caption li:not(.active)', function () {
      $(this)
        .addClass('active').siblings().removeClass('active')
        .closest('div.tabs-wrap').find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
      var ulIndex = $('ul.tabs__caption').index($(this).parents('ul.tabs__caption'));
      localStorage.removeItem('tab' + ulIndex);
      localStorage.setItem('tab' + ulIndex, $(this).index());
    });
  }

  function collectionFilter() {
    if ($('[data-collection-nav-filter]').length && $('[data-collection-nav-filter-dots]').length) {
      $('.collection__filter-strap').slick({
        variableWidth: false,
        slidesToShow: 7,
        centerMode: true,
        arrows: false,
        asNavFor: '.collection__filter-strap-dots',
        infinite: true,
        dots: false,
        initialSlide: $('.collection__filter-strap').find('.slick-slide.active').index(),
        centerPadding: '11.3%',
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              variableWidth: true,
              centerMode: true,
              infinite: true,
            }
          }]
      });
      $('.collection__filter-strap-dots').slick({
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: '.collection__filter-strap',
        arrows: false,
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '10%',
      })

    }

  }

  function productProtect() {
    var selectors = {
      protect: '#protect',
      protectFilter: '[data-protect-input]',
    };

    function hideKeyboard() {
      document.activeElement.blur();
      $("input").blur();
    }

    var getCookie = function (name) {
      var matches = document.cookie.match(new RegExp(
        '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    };
    var setCookie = function (name, value, options) {
      options = options || {};

      var expires = options.expires;

      if (typeof expires === 'number' && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
      }
      if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
      }

      value = encodeURIComponent(value);

      var updatedCookie = name + '=' + value;

      for (var propName in options) {
        updatedCookie += '; ' + propName;
        var propValue = options[propName];
        if (propValue !== true) {
          updatedCookie += '=' + propValue;
        }
      }

      document.cookie = updatedCookie;
    };

    var pass = $(selectors.protect).attr('data-section-code');

    if ($(selectors.protect).length) {
      $(selectors.protect).attr('data-section-code', '');

      if (!getCookie('page_protect')) {
        $(selectors.protect).removeClass('protect--hide');
        $('body').addClass('scroll-locked');
      }

      $(selectors.protectFilter).on('keyup', function () {
        if ($(this).val() !== '') {
          $(this).next().removeAttr('readonly');
          $(this).next().focus();
        } else {
          $(this).not(':first-child').attr('readonly', '');
          $(this).prev().focus();
        }
        let isValid = true;
        let code = '';
        $(selectors.protectFilter).each(function () {
          var element = $(this);
          if (element.val() === '') {
            isValid = false;
          }
          code = code + (element.val()).toString();
        });

        if (isValid) {
          if (pass === code) {
            $(selectors.protect).addClass('protect--hide');
            $('body').removeClass('scroll-locked');
            setCookie('page_protect', true, { path: '/' });
            hideKeyboard();
          } else {
            $(selectors.protectFilter).val('');
            $(selectors.protectFilter).first().focus();
          }
        }
      });
    }

  }
  function announcement() {
    if ($('[data-announcement]').length) {
      $('[data-announcement]').slick({
        autoplay: true,
        arrows: false, dots: false,
        autoplaySpeed: 3000,
        adaptiveHeight: false
      })
    }
  }
  function ajaxcart() {
    const labels = JSON.parse($('[data-product-success-labels]').html());
    const selectors = {
      cartOpen: '[data-cart-open]',
      cartClose: '[data-cart-close]',
      cart: '[data-cart]',
      cartList: '[data-cart-list]',
      cartCounter: '[data-cart-count]',
      cartEmpty: '[data-cart-empty]',
      cartItem: '[data-cart-item]',
      cartItemWrap: '[data-cart-item-wrap]',
      cartItemQuantity: '[data-cart-item-quantity]',
      cartItemQuantityInput: '[data-cart-item-quantity-input]',
      cartItemQuantityAction: '[data-cart-item-quantity-action]',
      cartItemOriginalPrice: '[data-cart-item-price]',
      cartItemRemove: '[data-cart-item-remove]',
      cartPrice: '[data-cart-price]',
      cartSubprice: '[data-cart-subprice]',
      productForm: '[data-product-form]',
      cartUpsell: '[data-cart-upsell]',
      cartFooter: '[data-cart-footer]',
    };


    $(document).on('click', selectors.cartItemQuantityAction, async function (e) {
      e.preventDefault();
      const cartItemOriginalPrice = $(this).closest(selectors.cartItem).find(selectors.cartItemOriginalPrice);
      const cartItemQuantityInput = $(this).closest(selectors.cartItemQuantity).find(selectors.cartItemQuantityInput);
      const itemId = parseInt(cartItemQuantityInput.attr('data-item-id'));

      let quantityValue = parseInt(cartItemQuantityInput.val());
      if ($(this).attr('data-cart-item-quantity-action') === 'plus') {
        

        if (quantityValue < 10) {
          quantityValue += 1;
          if (itemId) {
            await $.post('/cart/update.js', 'updates['+itemId+']='+quantityValue)
            .done(state => {
              state = JSON.parse(state);
              var item = state.items.find(item => item.id === itemId);
              cartItemQuantityInput.val(item.quantity);
              updatePrice(state, item, cartItemOriginalPrice);
            });
          } else {
            cartItemQuantityInput.val(quantityValue);
          }
        }
      } else {
        if (quantityValue > 1) {
          quantityValue -= 1;
          if (itemId) {
            $.post('/cart/update.js', 'updates['+itemId+']='+quantityValue).done(state => {
              state = JSON.parse(state);
              var item = state.items.find(item => item.id === itemId);
              cartItemQuantityInput.val(item.quantity);
              updatePrice(state, item, cartItemOriginalPrice);
            });
            
          } else {
            cartItemQuantityInput.val(quantityValue);
          }
        }
      }
    });

    $(document).on('click', selectors.cartItemRemove, async function (e) {
      e.preventDefault();
      const cartItemWrap = $(this).closest(selectors.cartItemWrap);
      const cartItemId = $(this).attr('data-id');
      await $.post('/cart/update','updates['+cartItemId+']=0')
      const state = await $.getJSON('/cart.js');
      updateAjaxCart(state, cartItemWrap);
    });

    $(document).on('submit', selectors.productForm, async function (e) {
      e.preventDefault(); 
      let form = $(this);
      const productProperties = {};
      const productID = parseInt($(this).find('[name=id]').val());
      const quantity = parseInt($(this).find('[name=quantity]').val()) || 1;
      const productProperty = $(this).find("input[name*='properties'][type='text'],input[name*='properties'][type='radio']:checked,input[name*='properties'][type='checkbox']:checked");
      if (productProperty.length) {
        productProperty.each(function (index, el) {
          const value = $(el).val();
          if (value === '') return;
          const name = $(el).attr('name').split('[')[1].split(']')[0];
          productProperties[name] = value;
        })
      }

      if (productID) {
        await $.post('/cart/add.js', form.serialize())
        .done(function(item){ 
          item = $.parseJSON(item);
          form.find('.product-message').addClass('success-message').removeClass('error-message').html(Theme.addToCartSuccess.replace('**product**', item.title).replace('**cart_link**', "<a href=\"/cart\">".concat(labels.cartLink, "</a>")).replace('**continue_link**', "<a href=\"/collections/all\">".concat(labels.continueLink, "</a>")).replace('**checkout_link**', "<a href=\"/checkout\">".concat(labels.checkoutLink, "</a>")))
         })
        .fail(function(error) {
          if (error.status == 422) 
          form.find('.product-message').html($.parseJSON(error.responseText).description).addClass('error-message').removeClass('success-message');
        }); 
        const state = await $.getJSON('/cart.js', function(state) { return state});
        updateAjaxCart(state)
      }
    });

    $(selectors.cartOpen).on('click', async function (e) {
      e.preventDefault();
      const state = await $.getJSON('/cart.js', function(state) { return state});
      updateAjaxCart(state);
      $('#ajaxCart').addClass('active');
    });
    $(selectors.cartClose).on('click', function (e) {
      e.preventDefault();
      $('#ajaxCart').removeClass('active');
    });
    


    function updatePrice(state, item, cartItemOriginalPrice) {
      let itemTotalPrice = item ? item.final_line_price : 1;
      let stateTotalPrice = state.total_price;
      let stateOriginalTotalPrice = state.original_total_price;

      if (cartItemOriginalPrice !== undefined) {  
        cartItemOriginalPrice.replaceWith('<span class="money" data-cart-item-price>' +Shopify.formatMoney(itemTotalPrice, Theme.moneyFormat) + '</span>');
      }

      $(selectors.cartPrice).html('<span class="money">' + Shopify.formatMoney(stateTotalPrice, Theme.moneyFormat) + '</span>');
      $(selectors.cartSubprice).html('<span class="money">' + Shopify.formatMoney(stateOriginalTotalPrice, Theme.moneyFormat) + '</span>');
      $(selectors.cartCounter).html(state.item_count); 
      if (state.item_count === 0) { 
        $(selectors.cartCounter).addClass('hide')
      } else {
        $(selectors.cartCounter).removeClass('hide')
      }
      if (typeof bcCurrencyConvert !== 'undefined')
        bcCurrencyConvert._convertAll($('[name=currencies]').val())
        // Currency.convertAll(window.shopCurrency, $('[name=currencies]').val());
    }
 
    function updateCart(state, cartItemWrap) {
      if (!state.items.length) {
        $(selectors.cart).addClass('hide');
        $(selectors.cartEmpty).removeClass('hide');
      } else {

      }
      if (cartItemWrap) {
        cartItemWrap.remove();
      }

      $(selectors.cartCounter).html(state.item_count);
      if (state.item_count === 0) {
        $(selectors.cartCounter).addClass('hide')
      } else {
        $(selectors.cartCounter).removeClass('hide')
      }
      $(selectors.cartPrice).html('<span class="money">' + Shopify.formatMoney(state.total_price, Theme.moneyFormat) + '</span>')
    }


    async function updateAjaxCart(state) {
      const ajaxCartTemplateHTML = ajaxCartTemplate(state);
      $(selectors.cartList).html(ajaxCartTemplateHTML);
      $(selectors.cartUpsell).html(await ajaxUpsellCartTemplate(state));
      $(selectors.cartCounter).html(state.item_count);
      if (state.item_count === 0) {
        $(selectors.cartCounter).addClass('hide')
      } else {
        $(selectors.cartCounter).removeClass('hide')
      }
      updatePrice(state);
      if (state.items.length) {
        $(selectors.cartFooter).removeClass('hide')
      } else {
        $(selectors.cartFooter).addClass('hide')

      }
      
      
      // $.magnificPopup.open({
      //   items: {
      //     src: '#ajaxCart',
      //     type: 'inline'
      //   },
      //   fixedContentPos: true,
      //   fixedBgPos: false,
      //   mainClass: 'mfp-ajax-cart',
      //   // callbacks: {
      //   //   open: function () {
      //   //     $('body').addClass('ov-hidden');
      //   //   },
      //   //   close: function () {
      //   //     $('body').removeClass('ov-hidden');
      //   //   }
      //   // }
      // });
      if (typeof bcCurrencyConvert !== 'undefined') {
        bcCurrencyConvert._convertAll($('[name=currencies]').val())  
      }
        
        // Currency.convertAll(window.shopCurrency, $('[name=currencies]').val());
        $('#ajaxCart').addClass('active');
    }

    const createUrl = (media) => {
      let url = undefined;
      let aspect_ratio;
      let imageSize;
      if (media) {
        url = media.url || media.src;
        aspect_ratio = media.aspect_ratio;
        imageSize = (media.height / media.width) * 100;
      }
      if (url) {
        const resolutions = ['180', '360', '540', '720', '900', '1080', '1240', '1500'];
        let ers = '';
        let ers_small = '';
        resolutions.map(res => {
          let newUrl = url.replace(/(\.[^\.]*)?$/, `_${res}x$1`);
          res === '180' ? ers_small = newUrl : '';
          newUrl += ` ${res}w`;
          if (ers === '') {
            ers = `${newUrl}`;
          } else {
            ers += `, ${newUrl}`;
          }

        })
        return `<div class="responsive-image__wrapper ">
    <div style="padding-top: ${imageSize}%" > </div>
    <img class="responsive-image__image lazyload" data-aspectratio="${aspect_ratio}" src="${ers_small}" data-sizes="auto" tabindex="-1" data-srcset="${ers}" data-widths="[180, 360, 540, 720, 900, 1080, 1240, 1500]"/>
    </div>`;
      } else return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>`;
    }

    const ajaxCartTemplate = (state) => {
      let ajaxCartItems = ``;
      if (state.items.length) {
        state.items.map((cartItem) => {
          ajaxCartItems += ajaxCartItemTemplate(cartItem)
        })
      }
      if (ajaxCartItems === '') {
        return `<p class="ajax-cart__empty text-center">Your cart is empty</p>`;
      } else {
        return ajaxCartItems;
      }
    }

    const ajaxUpsellCartTemplate = async (state) => {
      let upsellProduct;
    
      for (const item of state.items) {
        
        const ajaxUpsellProduct = await fetch(`/products/${item.handle}.js`, { method: 'GET' })
          .then((response) => {
            return response.json();
          }).then((data) => {
            return data;
          })
          .catch((error) => {
            console.log(error)
          });

        if (ajaxUpsellProduct) {
          if (ajaxUpsellProduct.tags.length) {
            let upsellProductHandle = ajaxUpsellProduct.tags.find(a => a.includes('upsell='))

            if (upsellProductHandle) {
              upsellProductHandle = upsellProductHandle.replace('upsell=', '')
              let newUpsellProduct = await fetch(`/products/${upsellProductHandle}.js`, { method: 'GET' }).then((response) => {
                return response.json();
              }).then((data) => { 
                return data;
              }).catch((error) => {
                console.log(error)
              });
              if (newUpsellProduct) {
                const inCart = state.items.find(a => a.handle === newUpsellProduct.handle)
                if (!inCart && newUpsellProduct.available) {
                  upsellProduct = newUpsellProduct;
                  break;
                }
              }
            }
          }
        }
      }


      if (upsellProduct) {
        let itemPrice = upsellProduct.price;
        let itemComparePrice = upsellProduct.compare_at_price;
        
          itemComparePrice = itemComparePrice > itemPrice ? `<s data-cart-item-sale-price><span class="money" >${formatMoney(itemComparePrice, Theme.moneyFormat)}</span></s>` : ``;
          itemPrice = `<span data-cart-item-price class="money">${Shopify.formatMoney(itemPrice, Theme.moneyFormat)}</span>`

        upsellProduct = `<div class="ajax-cart__upsell">
      <h2>${Theme.upsell}</h2>
      <div class="ajax-cart__upsell-item">
        <div class="ajax-cart__upsell-image">
          <a href="${upsellProduct.url}">
            ${createUrl(upsellProduct.media[0])}
          </a>
        </div> 
        <div class="ajax-cart__upsell-content">
          <div class="ajax-cart__upsell-info">
            <h3><a href="${upsellProduct.url}">${upsellProduct.title}</a></h3>
          </div>
          <div class="ajax-cart__upsell-price">
            ${itemPrice}
            ${itemComparePrice}
          </div>
          <form data-product-form method="post" action="/cart/add">
            <input type="hidden" name="quantity" value="1" >
            <input type="hidden" name="id" value="${upsellProduct.variants[0].id}">
            <button type="submit" class="button button--primary button--form button--wide">${Theme.addToCart}</button>
          </form>
        </div>
      </div>
    </div>`;
      } else {
        upsellProduct = '';
      }
      return upsellProduct;
    }

    const ajaxCartItemTemplate = (item) => {
      let itemFinalPrice = item.final_price;
      let itemOriginalPrice = item.original_price;
 
      itemOriginalPrice = itemOriginalPrice > itemFinalPrice ? `<s data-cart-item-sale-price ><span class="money">${Shopify.formatMoney(itemOriginalPrice * item.quantity, Theme.moneyFormat)}</span></s>` : ``;
      itemFinalPrice = `<span data-cart-item-price class="money">${Shopify.formatMoney(itemFinalPrice * item.quantity, Theme.moneyFormat)}</span>`



      let itemOptions = ``;
      let itemProperties = ``;
      if (item.options_with_values.length) {
        item.options_with_values.map(option => {
          itemOptions += option.value !== 'Default Title' ? `<p>${option.name}: ${option.value}</p>` : '';
        })
      }
      if (item.properties) {
        const keys = Object.keys(item.properties);
        keys.forEach(key => {
          itemProperties += `<p>${key}: ${item.properties[key]}</p>`;
        });
      }
      return `
  <div class="ajax-cart__item-wrap" data-cart-item-wrap> 
  <div class="ajax-cart__item" data-cart-item>
    <div class="ajax-cart__item-image">
        <a href="${item.url}">
           ${createUrl(item.featured_image)}
        </a>
    </div>
    <div class="ajax-cart__item-product">
      <h5 class="text-medium">
        <a href="${item.url}">${item.product_title}</a>
      </h5>
      <p>${item.variant_title ? item.variant_title : ``}</p>
      ${itemProperties}
      <div class="ajax-cart__item-quantity">
      <div class="quantity-control" data-cart-item-quantity>
        <span class="minus" data-cart-item-quantity-action="minus">-</span>
        <input type="text" readonly name="updates[]" data-item-id=${item.id} data-id="${item.id}" value="${item.quantity}" min="1" data-cart-item-quantity-input>
        <span class="plus" data-cart-item-quantity-action="plus">+</span>
      </div>
    </div>
    </div>
    
    <div class="ajax-cart__item-total-price">
      ${itemFinalPrice}
      ${itemOriginalPrice}
    </div>
    <div class="ajax-cart__item-remove">
      <a class="" data-cart-item-remove href="#" data-id="${item.id}">
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9612 16H3.01795C2.05394 16 1.27051 15.178 1.27051 14.1666V5.5C1.27051 5.224 1.48402 5 1.7471 5C2.01019 5 2.2237 5.224 2.2237 5.5V14.1666C2.2237 14.626 2.5801 15 3.01795 15H10.9612C11.3991 15 11.7556 14.626 11.7556 14.1666V5.5C11.7556 5.224 11.9691 5 12.2322 5C12.4953 5 12.7088 5.224 12.7088 5.5V14.1666C12.7088 15.178 11.9253 16 10.9612 16Z" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.476596 6H13.5035C13.7666 6 13.9801 5.776 13.9801 5.5V3.83337C13.9801 2.82202 13.1967 2 12.2327 2H1.74756C0.783544 2 0 2.82202 0 3.83337V5.5C0 5.776 0.213514 6 0.476596 6ZM13.0269 5H0.953192V3.83337C0.953192 3.37402 1.30971 3 1.74756 3H12.2327C12.6705 3 13.0269 3.37402 13.0269 3.83337V5Z" fill="black"/>
        <path d="M9.69048 3C9.42739 3 9.21388 2.776 9.21388 2.5V1.16663C9.21388 1.07471 9.14279 1 9.05505 1H4.92452C4.8369 1 4.76569 1.07471 4.76569 1.16663V2.5C4.76569 2.776 4.55218 3 4.2891 3C4.02601 3 3.8125 2.776 3.8125 2.5V1.16663C3.8125 0.523315 4.31132 0 4.92452 0H9.05505C9.66825 0 10.1671 0.523315 10.1671 1.16663V2.5C10.1671 2.776 9.95356 3 9.69048 3Z" fill="black"/>
        <path d="M6.99027 13.3334C6.72719 13.3334 6.51367 13.1094 6.51367 12.8334V8.5C6.51367 8.224 6.72719 8 6.99027 8C7.25335 8 7.46686 8.224 7.46686 8.5V12.8334C7.46686 13.1094 7.25335 13.3334 6.99027 13.3334Z" fill="black"/>
        <path d="M4.2891 13.3334C4.02601 13.3334 3.8125 13.1094 3.8125 12.8334V8.5C3.8125 8.224 4.02601 8 4.2891 8C4.55218 8 4.76569 8.224 4.76569 8.5V12.8334C4.76569 13.1094 4.55218 13.3334 4.2891 13.3334Z" fill="black"/>
        <path d="M9.69046 13.3334C9.42738 13.3334 9.21387 13.1094 9.21387 12.8334V8.5C9.21387 8.224 9.42738 8 9.69046 8C9.95354 8 10.1671 8.224 10.1671 8.5V12.8334C10.1671 13.1094 9.95354 13.3334 9.69046 13.3334Z" fill="black"/>
      </svg>      
      </a>
    </div>
  </div>
  </div>
</div>`;
    }




  }

  headerTabs();
  tabs();
  footer();
  infoLine();
  customTabs();
  collectionFilter();
  productProtect();
  announcement();
  ajaxcart()

  if ($('#email_signup').length) {
    KlaviyoSubscribe.attachToForms('#email_signup', {
      hide_form_on_success: true,
      extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
      }
    });
  }

});

